import nacl from "tweetnacl";
import { normalizeInboxPublicKeyHex } from "../../utils/inbox-crypto";

/** A usable X25519 inbox key; low-order points cannot protect a note secret. */
export function solanaRecipientInboxKey(value?: string): string | null {
  const normalized = normalizeInboxPublicKeyHex(value ?? "");
  if (!normalized) return null;
  const key = Uint8Array.from(
    Buffer.from(normalized.replace(/^0x/, ""), "hex"),
  );
  const shared = nacl.scalarMult(new Uint8Array(32).fill(42), key);
  return shared.some((byte) => byte !== 0) ? normalized : null;
}
